/*
 * Title: Rewards/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import Aside,  MobileHead, MobilePointStats, Tabshead,Navigation, RedeemContent from components.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React from "react";
import { connect } from "react-redux";
import SignupReward from "@components/SignupReward";
import EnterToWinAside from "@components/EnterToWin/Aside";
import MobileHeadETW from "@components/EnterToWin/MobileHead";
import EarnContent from "@components/EnterToWin/EarnContent";

type Props = {
  new_user_flag: boolean;
  addNewUserFlag: (flag: boolean) => void;
  setPageYOffset: (value: number) => void;
};
type MyState = {
};
class EnterToWin extends React.Component<Props | any, MyState> {
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    const timer = setTimeout(() => {
      this.props.addNewUserFlag(false);
    }, 3000);
    return () => clearTimeout(timer);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const { setPageYOffset } = this.props;
    const pageYOffset = window.pageYOffset;
    setPageYOffset(pageYOffset);
  };


  render() {
    const {isRegistrationEnd} = this.props;
    return (
      <div className="relative lg:h-[calc(100vh-90px)] h-full bg-body">
        <MobileHeadETW />
        <div className="h-full lg:px-10 px-5 lg:pt-0 pt-5 mx-auto">
          <div className="lg:grid lg:h-full lg:grid-cols-3 gap-4">
            <EnterToWinAside />
            <div className="lg:col-span-2">
              <EarnContent />
              {this.props.new_user_flag && <SignupReward />}
            </div>
          </div>
        </div>

        {/* when any action complete  */}
       
      </div>
    );
  }
}
const mapStateToProps = ({ user, score, creator }) => {
  return {
    score: score,
    new_user_flag: user.new_user_flag,
    isRegistrationEnd:creator?.isRegistrationEnd
  };
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
  const { dispatch } = dispatchProps;
  const { actions } = require("@redux/UserRedux");
  const { utilactions } = require("@redux/utilRedex");
  return {
    ...stateProps,
    addNewUserFlag: (flag: boolean) => {
      dispatch(actions.addNewUserFlag(flag));
    },
    setPageYOffset: (value: number) => dispatch(utilactions.setPageYOffset(value)),
  };
};

export default connect(mapStateToProps, undefined, mergeProps)(EnterToWin);